import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { Dispatch, SetStateAction, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from '../../../../components/Button';
import useModal from '../../../../hooks/useModal';
import { formatPrice } from '../../../../utils/utils';
import OnSaveModal from '../onSaveModal';
import NewEstimateForm from './newEstimateForm';
import PaymentConfirmation from './paymentConfirmation';

export type customEstimateFormProps = React.PropsWithoutRef<{
  showSecondForm: boolean;
  handleRemoveSecondScenario: () => void;
  showPaymentConfirmation: boolean;
  setShowPaymentConfirmation: Dispatch<SetStateAction<boolean>>;
  handleOnSave: any;
  isInline: boolean;
  handleBackToResults: any;
  handleFormsOfPayment: any;
}>;

const formsOfPaymentData1 = [
  {
    title: 'Single Life Anuity',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(3565.0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(11719.58, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '50% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2512.0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1256.0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '66 2/3% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2247.212, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '75% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1994.6, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '100% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1782.5, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1782.5, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '5 Year Certain & Continuous',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2822, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '10 Year Certain & Continuous',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2243, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '15 Year Certain & Continuous',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1876, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '5 Year Certain',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(3165.29, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(2582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(2247.12, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '10 Year Certain',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1994.6, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '15 Year Certain',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1782.5, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '5 Year Modified Cash Refund',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2822, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '10 Year Modified Cash Refund',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2243, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '15 Year Modified Cash Refund',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1876, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },
];

const formsOfPaymentData2 = [
  {
    title: 'Single Life Anuity',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2734, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(11719.58, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '50% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1712, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1256.0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '66 2/3% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1456, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '75% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1281, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '100% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(982.5, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1782.5, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '5 Year Certain & Continuous',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2822, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '10 Year Certain & Continuous',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1543, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '15 Year Certain & Continuous',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1876, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '5 Year Certain',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2247.12, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '10 Year Certain',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1994.6, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(1994.6, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '15 Year Certain',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1782.5, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '5 Year Modified Cash Refund',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2822, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '10 Year Modified Cash Refund',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2243, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '15 Year Modified Cash Refund',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1876, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },
];

const form1Data = {
  whenToStopWorking: undefined,
  whenToStartPension: undefined,
  beneficiaryBirthDate: undefined,
  percent: undefined,
};

const form2Data = {
  whenToStopWorking: undefined,
  whenToStartPension: undefined,
  beneficiaryBirthDate: undefined,
  percent: undefined,
};

const NewEstimateComparison = ({
  showSecondForm,
  handleOnSave,
  isInline,
  handleBackToResults,
  handleFormsOfPayment,
  handleRemoveSecondScenario,
  showPaymentConfirmation,
  setShowPaymentConfirmation,
}: customEstimateFormProps) => {
  const [form1, setForm1] = useState(form1Data);
  const [form2, setForm2] = useState(form2Data);
  const [selectedPaymentOptionScenario1, setSelectedPaymentOptionScenario1] =
    useState();
  const [selectedPaymentOptionScenario2, setSelectedPaymentOptionScenario2] =
    useState();

  const [showOnSaveModal, handleShowOnSaveModal, handleCloseOnSaveModal] =
    useModal();

  const handlePaymentOptionChangeScenario1 = (e: any) => {
    setSelectedPaymentOptionScenario1(e);
  };

  const handlePaymentOptionChangeScenario2 = (e: any) => {
    setSelectedPaymentOptionScenario2(e);
  };

  const handleSubmitFirstForm = (data: any) => {
    setForm1(data);
  };

  const handleSubmitSecondForm = (data: any) => {
    setForm2(data);
  };

  const getTerminationAndBeneficiaryPriceScenario1 = (type: string) => {
    switch (type) {
      case '1':
        return {
          termination: 3565,
          beneficiary: 0,
        };
      case '2':
        return {
          termination: 2512,
          beneficiary: 1256,
        };
      case '3':
        return {
          termination: 1782.5,
          beneficiary: 1782.5,
        };
      case '4':
        return {
          termination: 2243,
          beneficiary: 2243,
        };
    }
  };

  const getTerminationAndBeneficiaryPriceScenario2 = (type: string) => {
    switch (type) {
      case '1':
        return {
          termination: 2734,
          beneficiary: 0,
        };
      case '2':
        return {
          termination: 1712,
          beneficiary: 856,
        };
      case '3':
        return {
          termination: 982.5,
          beneficiary: 982.5,
        };
      case '4':
        return {
          termination: 1543,
          beneficiary: 1543,
        };
    }
  };

  const options = [
    { value: '1', label: 'Single Life Annuity' },
    { value: '2', label: '50% Joint & Survivor Annuity' },
    { value: '3', label: '100% Joint & Survivor Annuity' },
    { value: '4', label: '10 Year Certain & Continuous' },
  ];

  const calculateDataChartForm = (prices: any) => {
    let dataCharts: any = {
      chart1: [
        {
          color: '#2268E2',
          value: 0,
          name: 'balance',
          label: 'Cash Balance Plan',
          tooltipPrice: undefined,
        },
        {
          color: '#F93B1D',
          value: 0,
          name: 'qualified',
          label: 'Qualified Plan',
          tooltipPrice: undefined,
        },
        {
          color: '#10A84A',
          value: 0,
          name: 'non-qualified',
          label: 'Non-Qualified Plan',
          tooltipPrice: undefined,
        },
      ],
      chart2: [
        {
          color: '#2268E2',
          value: 0,
          name: 'balance',
          label: 'Cash Balance Plan',
          tooltipPrice: undefined,
        },
        {
          color: '#F93B1D',
          value: 0,
          name: 'qualified',
          label: 'Qualified Plan',
          tooltipPrice: undefined,
        },
        {
          color: '#10A84A',
          value: 0,
          name: 'non-qualified',
          label: 'Non-Qualified Plan',
          tooltipPrice: undefined,
        },
      ],
    };

    if (prices.termination) {
      dataCharts.chart1.map((e: any) => {
        if (e.name === 'qualified') {
          e.value = 50;
          e.tooltipPrice = prices.termination / 2;

          return e;
        }

        e.value = 25;
        e.tooltipPrice = prices.termination / 4;

        return e;
      });
    }

    if (prices.beneficiary) {
      dataCharts.chart2.map((e: any) => {
        if (e.name === 'qualified') {
          e.value = 50;
          e.tooltipPrice = prices.termination / 2;

          return e;
        }

        e.value = 25;
        e.tooltipPrice = prices.termination / 4;

        return e;
      });
    }

    return dataCharts;
  };

  let ageOfPension = 65;
  let ageOfPension1 = 60;

  return (
    <Row
      className={`m-0 py-10 px-11 border border-info rounded-1 ${
        showPaymentConfirmation ? 'bg-transperant' : 'bg-backgroud-gray'
      } ${!showSecondForm ? 'fit-content' : 'w-100'}`}
      style={!showSecondForm ? { maxWidth: 424 } : {}}
    >
      <Col
        className={`px-0 ${!showSecondForm ? 'col-12' : 'col-12 col-lg-6'} `}
      >
        {showSecondForm && (
          <div className="d-flex justify-content-between align-items-center">
            <h6 className="fw-normal mb-0 lh-sm text-sm-14-lg-20">
              Scenario 1
            </h6>
          </div>
        )}
        {showPaymentConfirmation ? (
          <PaymentConfirmation
            dataCharts={calculateDataChartForm(
              getTerminationAndBeneficiaryPriceScenario1(
                selectedPaymentOptionScenario1 || '1'
              )
            )}
            prices={getTerminationAndBeneficiaryPriceScenario1(
              selectedPaymentOptionScenario1 || '1'
            )}
            ageOfPension={ageOfPension}
            selectedPaymentOption={selectedPaymentOptionScenario1}
            visibleFormsOfPayment
            formsOfPaymentTableData={formsOfPaymentData1}
            paymentOptions={options}
            isInline={isInline}
            handleFormsOfPayment={handleFormsOfPayment}
            handleBackToResults={handleBackToResults}
            handlePaymentOptionChange={handlePaymentOptionChangeScenario1}
          />
        ) : (
          <NewEstimateForm collectData={handleSubmitFirstForm} data={form1} />
        )}
      </Col>
      {showSecondForm && (
        <Col
          className={`px-0 px-lg-5 mt-12 mt-lg-0 ${
            !showSecondForm ? 'col-12' : 'col-12 col-lg-6'
          } `}
        >
          <div className="d-flex justify-content-between align-items-center">
            <h6 className="fw-normal mb-0 lh-sm text-sm-14-lg-20">
              Scenario 2
            </h6>
            <Button
              size="sm"
              variant="transperant"
              leftIcon={light('trash-can')}
              onClick={handleRemoveSecondScenario}
            >
              Remove Scenario
            </Button>
          </div>
          {showPaymentConfirmation ? (
            <PaymentConfirmation
              dataCharts={calculateDataChartForm(
                getTerminationAndBeneficiaryPriceScenario2(
                  selectedPaymentOptionScenario2 || '1'
                )
              )}
              prices={getTerminationAndBeneficiaryPriceScenario2(
                selectedPaymentOptionScenario2 || '1'
              )}
              ageOfPension={ageOfPension1}
              paymentOptions={options}
              visibleFormsOfPayment
              isInline={isInline}
              handleBackToResults={handleBackToResults}
              handleFormsOfPayment={handleFormsOfPayment}
              formsOfPaymentTableData={formsOfPaymentData2}
              handlePaymentOptionChange={handlePaymentOptionChangeScenario2}
            />
          ) : (
            <NewEstimateForm
              collectData={handleSubmitSecondForm}
              data={form2}
            />
          )}
        </Col>
      )}
      <Col className="d-flex justify-content-end">
        {showPaymentConfirmation ? (
          <>
            <Button
              variant="primary-outline"
              className="order-1 order-lg-2 mt-10"
              onClick={() => {
                setShowPaymentConfirmation(false);
              }}
            >
              Edit
            </Button>
            <Button
              variant="primary"
              onClick={isInline ? handleOnSave : handleShowOnSaveModal}
              className="order-1 order-lg-2 mt-10 ms-4"
            >
              Save
            </Button>
            <OnSaveModal
              showModal={showOnSaveModal}
              handleClose={handleCloseOnSaveModal}
            />
          </>
        ) : (
          <Button
            variant="primary"
            className="order-1 order-lg-2 mt-10"
            onClick={() => {
              setShowPaymentConfirmation(true);
            }}
          >
            Calculate
          </Button>
        )}
      </Col>
    </Row>
  );
};

export default NewEstimateComparison;
